import React from "react";
import { CircularProgress, Typography, Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useTranslation } from "react-i18next";
import { UploadStatus } from "../../hooks/useFileUpload";

type UploadStatusIndicatorProps = {
  status: UploadStatus;
  error?: string | null;
};

const UploadStatusIndicator = ({ status, error }: UploadStatusIndicatorProps) => {
  const { t } = useTranslation();

  if (status === "idle") return null;

  return (
    <Box display="inline-flex" alignItems="center" gap={1} ml={1}>
      {status === "uploading" && (
        <>
          <CircularProgress size={18} />
          <Typography variant="caption" color="textSecondary">
            {`${t("Common.Uploading")}...`}
          </Typography>
        </>
      )}
      {status === "success" && (
        <>
          <CheckCircleOutlineIcon fontSize="small" color="success" />
          <Typography variant="caption" color="success.main">
            {t("Common.UploadSuccess")}
          </Typography>
        </>
      )}
      {status === "error" && (
        <>
          <ErrorOutlineIcon fontSize="small" color="error" />
          <Typography variant="caption" color="error">
            {error || t("Common.UploadFailed")}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default UploadStatusIndicator;
